// Copyright (c) 2024 Lenovo. All right reserved.
// Confidential and Restricted
import Vue from 'vue'
import axios from 'axios';
import router from "@/router";
import store from "@/store";
import { Message } from '@/utils/plugins.js';

// Set timeout event
axios.defaults.timeout = 0.5 * 60000;
// Set default request header
axios.defaults.headers.post['Content-Type'] = 'application/json'; // FORM application/x-www-form-urlencoded;charset=UTF-8
//axios.defaults.headers.get['Cache-Control'] = 'no-cache'; // FORM application/x-www-form-urlencoded;charset=UTF-8
//axios.defaults.headers.post['Cache-Control'] = 'no-cache'; // FORM application/x-www-form-urlencoded;charset=UTF-8

// Request IP
Vue.prototype.BaseIp = window.serverIp || process.env.VUE_APP_API_BASE_URL_BT;

// Default Address
axios.defaults.baseURL = Vue.prototype.BaseIp;

// List of requests without carrying tokens
const noTokenRequestUrl = [
    // Public Key
    {
        url: '/system/auth/getPublicKey',
    },
    // log on
    {
        url: '/system/auth/login'
    },
    // register
    {
        url: 'sys_user/register'
    },
    // Is MFA bound
    {
        url: '/system/auth/hasMFACode'
    },
    // Do you want to return MFA images
    {
        url: '/system/auth/getTotpPicByUserInfo'
    },
    // reset password
    {
        url: '/system/user/resetPasswordByUserName'
    },
    // Verify admin
    {
        url: '/system/auth/auth'
    }
];

// List of allowed requests when resetting password
const resetPasswordRequestUrl = ['/system/user/updatePassword'];
// Determine whether to carry a token
function isNeedToken(requestUrl) {
    for (let i = 0; i < noTokenRequestUrl.length; i ++) {
        if(requestUrl.includes(noTokenRequestUrl[i].url)) {
            return false;
        }
    }
    return true;
}

const getRefreshToken = ()=>{
    //return sessionStorage.rToken;
    return window.getCookie('rToken');
}

const refreshToken = async () => {
  //axios.defaults.headers.common['tenant-id'] = getTenantId()
  let base_url = axios.defaults.baseURL;
  return await axios.post(base_url + '/system/auth/refresh-token?refreshToken=' + getRefreshToken())
}



axios.interceptors.request.use(

    config => {
        //Vue.prototype.$showUpdatePassword(true); // add by wuweiwei for test
        //Check if there is a token in Vuex before sending each request
        //If it exists, add a token to the header of the HTTP request uniformly, so that the backend can determine your login status based on the token
        //Even if the token exists locally, it is still possible that the token has expired, so it is necessary to determine the return status in the response interceptor
        //No token or token carrying interface is required for normal return, no other return is required

        //let token = (isNeedToken(config.url) && sessionStorage.token) || '';
        let token;
        if(window.isProduction())
        {
            token = (isNeedToken(config.url)) || '';
        }
        else
        {
            token = (isNeedToken(config.url) && window.getCookie('token')) || '';
        }

        if(token && !router.history.current.path.includes('login') && store.getters.isFirstLogin && !resetPasswordRequestUrl.includes(config.url)) {
            throw { key: 'throwKey', code: 1000, message: 'This is my first login' }; // 1000 Throwing error codes for customization
        }
        
        if(token) 
            config.headers = {
                ...config.headers,
                Authorization: token
            }; // Only when there is a token will it be passed in
        
        // Repeated submission processing
        const requestObj = {
            url: config.url,
            data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
            time: new Date().getTime()
        }
        
        const sessionObj = JSON.parse(sessionStorage.getItem('sessionObj') || '{}');
        if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
            sessionStorage.setItem('sessionObj', JSON.stringify(requestObj));
        } else {
            const s_url = sessionObj.url;                  // Request Address
            const s_data = sessionObj.data;                // request data
            const s_time = sessionObj.time;                // request time
            const interval = 3000;                         // Interval time (ms), if less than this time, it is considered a duplicate submission

            if (config.method !== 'get' && !config.needMore && s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
                // const message = 'The data is being processed, please do not resubmit';
                // Message.error(message);
                /*
                if(config.url.indexOf("refresh-token")>0)
                {
                    router.push({
                        path: '/login'
                    }); 
                }
                */
                throw { key: 'throwKey', code: 1001, message: Vue.prototype.$tran('The data is being processed。 Please do not submit again。') };
            } else {
                sessionStorage.setItem('sessionObj', JSON.stringify(requestObj))
            }
        }
        /*
        if(token || !isNeedToken(config.url)){ //not use custom token
            return config;
        } else {
            Message.error('Your session has expired。 Please log in again。');
            //sessionStorage.token = '';
            window.removeCookie('token');
            window.removeCookie('rToken');
            router.push({                        
                path: '/login'
            });
        }
        */

        return config;
    },    
    error => {        
        return Promise.error(error);
    }
)

const catchError = function(responseInfo = {}) {
    let alertMessage = responseInfo.msg;
    switch (responseInfo.code || 999) {
        case 401:
            alertMessage = 'Your session has expired。 Please log in again。';
            //sessionStorage.token = "";
            window.removeCookie('token');
            window.removeCookie('rToken');
            router.push({ path: '/login' });
        break;
        case 404:
            alertMessage = 'Invalid network request URL';
        break;
        case 500:
            alertMessage = 'Unknown server error';
        break;
        case 996:
            alertMessage = alertMessage;
        break;
        case 999:
            alertMessage = 'An unknown error has occurred';
        break;
    }
    if(!responseInfo.isSelfDealRes) {
        Message.error(alertMessage);
    }
    return { ...responseInfo, msg: alertMessage };
}

/**
 * Request responder
 */
axios.interceptors.response.use(
    async (response) => {
        try
        {
            let msg = response.data.msg;
            
            if(!!msg)
            {
                msg = msg.replace(/\./g,"。").replace(/,/g,"，").replace(/'/g,"’");
                response.data.msg = msg;
            }
        }
        catch(e){};
        window.backendCode = response.data.code;  // save currrent response state code ,like 401(Token existieren nicht), 401 code must close loading
        /** Both cases return true: 1:  The HTTP response code is 200, and the request code is also normal (usually 200) 2: When downloading a file (get type request is the download) */
        if ((response.status === 200 && response.data && response.data.code === 200) || (response.config && response.config.specialType === 'download' && response.config.method === 'get')) {
            if(response.config && response.config.specialType === 'download') {
                return Promise.resolve({ code: 200, data: response.data, msg: 'Download successful' });
            } else {
                return Promise.resolve(response.data);
            }
        }
        else if(response.data.code == 401)
        {
            if(window.isProduction())
            {
                localStorage.setItem("isGetToken","false");
            }
            
         
            try
            {
                //window.removeCookie('token');
                //window.removeCookie('rToken');
                Message.error('Your session has expired。 Please log in again。');
                router.push({ path: '/login' });
                /*
                if(!window.mouseMonitor.isAlive())
                {
                    //sessionStorage.rToken = "";
                    //sessionStorage.token = "";
                    window.removeCookie('token');
                    window.removeCookie('rToken');
                    router.push({ path: '/login' });
                }
                else
                {
                    const refreshTokenRes = await refreshToken();
          
                    //sessionStorage.setItem('token', refreshTokenRes.data.accessToken);
                    //sessionStorage.setItem('rToken', refreshTokenRes.data.refreshToken);
                    window.setCookie('token', refreshTokenRes.data.accessToken);
                    window.setCookie('rToken', refreshTokenRes.data.refreshToken);
                }
                */
                return Promise.resolve(response.data);
            }
            catch (e)
            {

            }
            finally 
            {

            }
        }
        else if(response.data.code == 403)
        {
            if(window.isProduction())
            {
                localStorage.removeItem("isGetToken");
                router.push({ path: '/login' });                
            }
        }
        else
        {
            let temResponse = { ...(response.data || {}) };
            if(response.config && response.config.isSelfDealRes === true) {
                temResponse = {
                    code: 996,
                    msg: temResponse.msg,
                    isSelfDealRes: true
                }
            }

            return catchError(temResponse);
        }
    },
    error => {
        if(error && error.key !== 'throwKey') {

            let temCode, temMessage;
            if(error.config && error.config.isSelfDealRes) {
                temCode = 996;
                temMessage = null;
            } else if(error.code === 'ECONNABORTED' && error.message && error.message.includes('timeout') && !error.config._retry){ // Determine if the timeout has occurred
                temCode = 998;
                temMessage = 'Request timeout Please check your network and try again';
            } else if(error.message && error.message.includes(`'setRequestHeader' on 'XMLHttpRequest':`)){ // Judging not
                temCode = 997;
                temMessage = 'Illegal request header!';
            } else if (error.code === "ERR_NETWORK") {
                temCode = 995;
                temMessage = 'Failed to connect to server';
            } else {
                temCode = error.response && error.response.status;
                temMessage = error.message;
            }

            return catchError({ code: temCode, msg: temMessage });
        } else if(error.key === 'throwKey') {
            switch (error.code) {
                case 1000:
                    if(!store.state.isLoginDialogShow) {
                        Vue.prototype.$showUpdatePassword(true);
                    }
                break;

                case 1001:
                    Message.error(error.message);
                break;
            
                default:
                break;
            }
        }
    }
)

export default axios;